import RiskProfileIcon from '@assets/images/risk-profile/riskProfile.svg';
import { Box, Typography, useTheme } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

const styleBox = {
  display: 'flex',
  alignItems: 'left',
  borderRadius: '8px',
  padding: '12px 16px 12px 16px',
  backgroundColor: '#fffff',
  border: '1px solid #DCDDDF',
  boxShadow: '0 4px 6px #DCDDDF',
  gap: '8px',
};

const innerStyleBox = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const RiskLevelBox = ({
  testId,
  riskLevel,
  riskLevelDescription,
}: {
  testId?: string;
  riskLevel: string;
  riskLevelDescription?: string;
}) => {
  const theme = useTheme();
  const { t } = useTranslation('riskProfile');

  return (
    <>
      <Box data-testid={testId ?? 'risk-level-box'} sx={styleBox}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box sx={innerStyleBox}>
            <img src={RiskProfileIcon} alt='risk-profile-icon'></img>
          </Box>
          <Box
            sx={[
              {
                ml: 1,
              },
              ...(Array.isArray(innerStyleBox)
                ? innerStyleBox
                : [innerStyleBox]),
            ]}
          >
            <Typography
              variant='bodyLarge'
              sx={{ fontWeight: 600, display: 'contents' }}
            >
              {t('riskProfileIs')}
              <Box
                sx={{
                  color: theme.color.primary,
                  marginLeft: '5px',
                  display: 'inline-block',
                }}
              >
                {riskLevel}
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          margin: '20px 0',
        }}
      >
        <Typography
          variant='bodySmall'
          component='p'
          sx={{ fontSize: '14px', lineHeight: '20px', letterSpacing: '0.5px' }}
        >
          {riskLevelDescription}
        </Typography>
      </Box>
    </>
  );
};
